@if (isLoading()) {
  <clr-spinner class="margin-10-t" [clrInline]="true" [clrSmall]="true" />
} @else {
  <clr-wizard
    #wizard
    [clrWizardOpen]="isModalOpen()"
    [clrWizardSize]="'full-screen'"
    (clrWizardOnCancel)="isModalOpen.set(false)"
    class="h-100-stop">
    <clr-wizard-title>
      {{ 'Auftrag erstellen' | mrTranslate }}
      @if (!isImportedInfor()) {
        <clr-checkbox-container clrInline>
          <clr-checkbox-wrapper>
            <label>{{ 'Mängel über Objekte auswählen' | mrTranslate }}</label>
            <input
              type="checkbox"
              clrToggle
              [(ngModel)]="isObjectSelect"
              (ngModelChange)="toggledSelectObjekt(wizard)"
              [ngModelOptions]="{ standalone: true }" />
          </clr-checkbox-wrapper>
        </clr-checkbox-container>
      }
    </clr-wizard-title>

    <clr-wizard-button [type]="'cancel'">{{ 'Abbrechen' | mrTranslate }}</clr-wizard-button>
    <clr-wizard-button [type]="'previous'">{{ 'Zurück' | mrTranslate }}</clr-wizard-button>
    <clr-wizard-button [type]="'next'">{{ 'Weiter' | mrTranslate }}</clr-wizard-button>
    <clr-wizard-button [type]="'finish'">{{ 'Auftrag absenden' | mrTranslate }}</clr-wizard-button>

    <clr-wizard-page [clrWizardPageNextDisabled]="auftragGroup.invalid">
      <ng-template clrPageTitle>{{ 'Auftragsdaten' | mrTranslate }}</ng-template>

      <form
        #auftragForm
        clrForm
        [formGroup]="auftragGroup"
        clrLayout="horizontal"
        [clrLabelSize]="4"
        class="width100"
        style="max-width: 50em">
        @if (auftragGroup.errors?.['start-after-and']) {
          <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6 clr-break-row">
            <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
              <clr-alert-item>
                <span class="alert-text">
                  {{ 'Das Startdatum muss früher als das Enddatum sein' | mrTranslate }}
                </span>
              </clr-alert-item>
            </clr-alert>
          </div>
          <!--* <div class="clr-break-row"></div> -->
        }
        <clr-control-container>
          <label class="clr-required-mark">{{ 'Titel' | mrTranslate }}</label>
          <app-datalist-input [datalist]="titel()" placeholder="" formControlName="titel" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-control-container>
        <clr-date-container>
          <label class="clr-required-mark">{{ 'Startdatum' | mrTranslate }}</label>
          <input
            type="date"
            clrDate
            [ngModel]="auftragGroup.get('startdate').value | localeDate"
            (ngModelChange)="auftragGroup.get('startdate').setValue(localeDate.tosql($event))"
            [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
            required />
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
        </clr-date-container>
        <clr-date-container>
          <label class="clr-required-mark">{{ 'Enddatum' | mrTranslate }}</label>
          <input
            type="date"
            clrDate
            [ngModel]="auftragGroup.get('enddate').value | localeDate"
            (ngModelChange)="auftragGroup.get('enddate').setValue(localeDate.tosql($event))"
            [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
            required />
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
        </clr-date-container>
        <clr-select-container>
          <label class="clr-required-mark">{{ 'Auftragnehmer' | mrTranslate }}</label>
          <select clrSelect formControlName="auftragnehmer">
            <option [ngValue]="-1" disabled>{{ 'Auftragnehmer auswählen' | mrTranslate }}</option>
            @for (firm of firmen(); track $index) {
              <option [ngValue]="+firm.ID">{{ firm.mFirma }}</option>
            }
          </select>
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
        </clr-select-container>
        <clr-select-container>
          <label class="clr-required-mark">{{ 'Auftragsgruppe' | mrTranslate }}</label>
          <select clrSelect formControlName="auftragsgruppe">
            <option [ngValue]="null" disabled>{{ 'Auftragsgruppe auswählen' | mrTranslate }}</option>
            @for (group of gruppen(); track $index) {
              <option [ngValue]="+group.id">{{ group.Bezeichnung }}</option>
            }
          </select>
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
        </clr-select-container>
        <clr-control-container>
          <label [class.clr-required-mark]="isHxGN_Interface">{{ 'Auftragsart' | mrTranslate }}</label>
          <app-datalist-input [datalist]="auftragsart()" placeholder="" formControlName="auftragsart" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-control-container>
        <clr-input-container>
          <label>{{ 'Auftragsnummer' | mrTranslate }}</label>
          <input clrInput type="text" formControlName="auftragsnr" />
        </clr-input-container>
        <clr-control-container>
          <label [class.clr-required-mark]="isHxGN_Interface">{{ 'Kostenart' | mrTranslate }}</label>
          <app-datalist-input [datalist]="kostenart()" placeholder="" formControlName="kostenart" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-control-container>
        @if (showInterfaceDetail()) {
          @let ursache = auftragGroup.get('stoerursache').value;
          <clr-select-container>
            <label class="d-f row w-100-p">
              <span class="clr-required-mark clr-col nxp ellipsis">{{ 'Ursache' | mrTranslate }}</span>
              <button
                class="btn btn-sm btn-icon btn-outline clr-col-auto"
                style="margin: -7px 0; float: inline-end"
                tabindex="-1"
                type="button"
                [title]="'Tabelle verwalten' | mrTranslate"
                (click)="isBaseItemModalOpen.set(true)">
                <cds-icon shape="pencil" />
              </button>
            </label>
            <select clrSelect formControlName="stoerursache">
              <option [ngValue]="null" disabled>{{ 'Ursache auswählen' | mrTranslate }}</option>
              @if (ursache && !stoerursache().includes(ursache)) {
                <option [value]="ursache" class="invalid-red">{{ ursache }}</option>
              }
              @for (item of stoerursache(); track $index) {
                <option [value]="item">{{ item }}</option>
              }
            </select>
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            <clr-control-error *clrIfError="'not-in-Table'; error as err">
              {{ err | mrTranslate }}
            </clr-control-error>
          </clr-select-container>
          <clr-select-container>
            <label class="clr-required-mark">{{ 'Störgrund' | mrTranslate }}</label>
            <select clrSelect formControlName="stoergrund">
              <option [ngValue]="null" disabled>{{ 'Störgrund auswählen' | mrTranslate }}</option>
              @for (item of stoergrund(); track $index) {
                <option [value]="item">{{ item }}</option>
              }
            </select>
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
          </clr-select-container>
          <clr-date-container>
            <label>{{ 'Störbeginn' | mrTranslate }}</label>
            <input
              type="date"
              clrDate
              [ngModel]="auftragGroup.get('stoerbeginn').value | localeDate"
              (ngModelChange)="auftragGroup.get('stoerbeginn').setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
          </clr-date-container>
          <clr-input-container>
            <input clrInput type="time" formControlName="stoerbeginnzeit" placeholder="00:00" />
          </clr-input-container>
          <clr-date-container>
            <label>{{ 'Störende' | mrTranslate }}</label>
            <input
              type="date"
              clrDate
              [ngModel]="auftragGroup.get('stoerende').value | localeDate"
              (ngModelChange)="auftragGroup.get('stoerende').setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
          </clr-date-container>
          <clr-input-container>
            <input clrInput type="time" formControlName="stoerendezeit" placeholder="00:00" />
          </clr-input-container>
          <clr-control-container>
            <label>{{ 'Festgestellt' | mrTranslate }}</label>
            <app-datalist-input [datalist]="stoererfasser()" placeholder="" formControlName="stoererfasser" />
          </clr-control-container>
        }
        <clr-textarea-container>
          <label>{{ 'Bemerkung' | mrTranslate }}</label>
          <textarea clrTextarea rows="3" formControlName="bemerkung"></textarea>
        </clr-textarea-container>
      </form>

      @if (isHxGN_Interface && !isImportedInfor()) {
        <form clrForm clrLayout="horizontal" [clrLabelSize]="4" class="width100" style="max-width: 50em">
          <clr-checkbox-container>
            <label>{{ 'HxGN EAM Auftrag import' | mrTranslate }}</label>
            <clr-checkbox-wrapper>
              <input type="checkbox" clrToggle ngModel #isImport="ngModel" [ngModelOptions]="{ standalone: true }" />
            </clr-checkbox-wrapper>
          </clr-checkbox-container>

          @if (isImport.value) {
            <clr-input-container>
              <label class="clr-required-mark">{{ 'Auftragsnummer' | mrTranslate }}</label>
              <input
                clrInput
                type="text"
                [(ngModel)]="importedAuftragNr"
                [ngModelOptions]="{ standalone: true }"
                required />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
            </clr-input-container>
            <div class="btn-group btn-outline margin-10-t">
              <button class="btn btn-sm" [disabled]="!importedAuftragNr()" (click)="importHxGNAuftrag()">
                {{ 'HxGN EAM Auftrag import' | mrTranslate }}
                @if (isImportedInforLoad()) {
                  <clr-spinner [clrInline]="true" [clrSmall]="true" />
                }
              </button>
            </div>
          }
        </form>
      }
    </clr-wizard-page>

    @if (isObjectSelect()) {
      <clr-wizard-page [clrWizardPageNextDisabled]="!savedSelectedObjekte().length" class="d-f col h-100 h-100-parent">
        <ng-template clrPageTitle>
          {{ 'Objekte' | mrTranslate }}
          <app-all-selected-btn
            class="btn-sm"
            [(selected)]="selectedObjekte"
            [all]="objekteFilterStore.filteredRows()" />

          @if (objekteFilterStore.filteredRows().length != objekte().rows.length) {
            <button class="btn btn-primary btn-sm btn-icon" (click)="objekteFilterStore.deleteAllFilters()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="filter-off" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Alle Filter zurücksetzen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          }
          @if (savedSelectedObjekte().length) {
            <button
              class="btn btn-primary btn-sm nym clr-align-self-center"
              (click)="selectedObjekte.set([]); savedSelectedObjekte.set([])">
              {{ 'Auswahl zurücksetzen' | mrTranslate }}
            </button>
          }
        </ng-template>
        <ng-template clrPageNavTitle>{{ 'Objekte' | mrTranslate }}</ng-template>
        @defer (on viewport) {
          @if (objekte().columns.length) {
            <clr-datagrid
              class="datagrid-compact fill-space"
              [clrDgItemsIdentityFn]="row => row?.OSTAMMID"
              [clrDgRowSelection]="true"
              [clrDgSelectionType]="'multi'"
              [clrDgSelected]="selectedObjekte()"
              (clrDgSelectedChange)="selectedObjekte.set($event)">
              @for (column of objekte().columns; track column.id) {
                <clr-dg-column [clrDgField]="column.id">
                  <clr-dg-filter [attr.data-test-id]="'datagrid-new-auftrag-objekte-col-filter-' + column.id">
                    <app-column-filter
                      #objekte
                      [column]="column"
                      [objektTypIconValue]="objekteFilterStore.iconMap()"
                      [uniqueColumnValues]="objekteFilterStore.uniqueValues()[column.id]"
                      (changes)="objekteFilterStore.onChange($event)" />
                  </clr-dg-filter>
                  <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                    {{ column.id | titlecase | mrTranslate }}
                  </ng-container>
                </clr-dg-column>
              }
              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="objekteFilterStore.filteredRows()"
                [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID"
                [clrVirtualRowsItemSize]="33">
                <clr-dg-row [clrDgItem]="row">
                  @for (cell of objekte().columns; track cell.id) {
                    <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                  }
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>{{ objekteFilterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>

            <div class="datagrid-compact" style="max-height: 250px">
              <div class="grid datagrid" id="saved-objekte-grid-container">
                <div class="border-table h-100 scroll">
                  @let ignoreCols =
                    [
                      'kav',
                      'sp',
                      'lf',
                      'si',
                      'st',
                      'rep',
                      'prüfdatum',
                      'messdatum',
                      'länge',
                      'leistungslänge',
                      'username',
                      'status',
                      'ebl',
                      'alv',
                      'ebl name',
                      'alv name',
                      'ebl datum',
                      'alv datum',
                      'ebl bemerkung',
                      'alv bemerkung',
                      'ebl info',
                      'alv info',
                    ];
                  <table class="table margin-0-t table-compact">
                    <thead style="position: sticky; top: -1px; z-index: 3">
                      <tr>
                        <th class="left name-cell">{{ 'Löschen' | mrTranslate }}</th>

                        @for (column of objekte().columns; track column.id) {
                          @if (!(column.id | hideIDColumns: ignoreCols)) {
                            <th class="left name-cell">{{ column.id | titlecase | mrTranslate }}</th>
                          }
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of savedSelectedObjekte(); track row.OSTAMMID) {
                        <tr>
                          <td class="left name-cell">
                            <button
                              class="btn btn-link w-h-auto"
                              (click)="deleteFromSaved('Objekte', $index)"
                              [title]="'vom Auswahl löschen' | mrTranslate">
                              <cds-icon shape="times" />
                            </button>
                          </td>
                          @for (cell of objekte().columns; track cell.id) {
                            @if (cell.id.toLowerCase() == 'typ') {
                              <td class="left name-cell fill-black">
                                <cds-icon
                                  class="grid-icon"
                                  [title]="row['typ']"
                                  size="28"
                                  [shape]="row['typ_icon'] ? 'objekttyp' + row['typ_icon'] : 'unknown-status'" />
                              </td>
                            } @else if (!(cell.id | hideIDColumns: ignoreCols)) {
                              <td class="left name-cell">{{ row[cell.id] | tablePrettyPrint }}</td>
                            }
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <div class="datagrid-footer">
                  <span class="datagrid-footer-select">
                    <cds-icon size="18" shape="checkbox-list" />
                    &nbsp;{{ savedSelectedObjekte().length }}
                  </span>
                </div>
              </div>
            </div>
          }
        } @placeholder {
          <clr-spinner class="centred" />
        }
      </clr-wizard-page>
    }

    <ng-template #newMangelCheckbox>
      @if (isObjectSelect() && !isImportedInfor()) {
        <span class="margin-10-lr">|</span>
        <clr-checkbox-container clrInline style="display: inline-flex">
          <clr-checkbox-wrapper>
            <label>{{ 'Neue Mängel erstellen' | mrTranslate }}</label>
            <input type="checkbox" clrToggle [(ngModel)]="createNewMaengel" [ngModelOptions]="{ standalone: true }" />
          </clr-checkbox-wrapper>
        </clr-checkbox-container>
      }
    </ng-template>

    @if (createNewMaengel()) {
      <clr-wizard-page [clrWizardPageNextDisabled]="!neuMaengel().length">
        <ng-template clrPageTitle>
          {{ 'Neue Mängel erstellen' | mrTranslate }}
          <ng-container *ngTemplateOutlet="newMangelCheckbox" />
        </ng-template>
        <ng-template clrPageNavTitle>{{ 'Mängel erstellen' | mrTranslate }}</ng-template>
        <div class="clr-row">
          <form clrForm [formGroup]="newMangelGroup" (ngSubmit)="createMangel()" class="clr-col-6 width100">
            <clr-input-container>
              <label class="clr-required-mark">{{ 'Titel' | mrTranslate }}</label>
              <input clrInput type="text" formControlName="titel" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
            </clr-input-container>
            <clr-textarea-container>
              <label>{{ 'Beschreibung' | mrTranslate }}</label>
              <textarea clrTextarea rows="3" formControlName="beschreibung"></textarea>
            </clr-textarea-container>
            <clr-input-container>
              <label>{{ 'Umfang' | mrTranslate }}</label>
              <input clrInput type="text" formControlName="umfang" />
            </clr-input-container>
            <clr-select-container>
              <label>{{ 'Mengeneinheit' | mrTranslate }}</label>
              <select clrSelect formControlName="mengeneinheit">
                <option [ngValue]="null" disabled>{{ 'Mengeneinheit auswählen' | mrTranslate }}</option>
                @for (item of meh(); track $index) {
                  <option [value]="item.bezeichnung">{{ item.bezeichnung | mrTranslate }}</option>
                }
              </select>
            </clr-select-container>
            <clr-textarea-container>
              <label>{{ 'Bemerkung' | mrTranslate }}</label>
              <textarea clrTextarea rows="3" formControlName="bemerkung"></textarea>
            </clr-textarea-container>
            <button type="submit" class="btn btn-sm btn-primary" [disabled]="newMangelGroup.invalid">
              {{ 'Mangel erstellen' | mrTranslate }}
            </button>
          </form>
          <clr-datagrid class="datagrid-compact clr-col-6">
            @let columns = ['titel', 'beschreibung', 'umfang', 'mengeneinheit', 'bemerkung'];
            <clr-dg-column [style.max-width.px]="30">
              {{ 'Löschen' | mrTranslate }}
            </clr-dg-column>
            @for (column of columns; track $index) {
              <clr-dg-column [clrDgField]="column">
                <ng-container *clrDgHideableColumn="{ hidden: false }">
                  {{ column | mrTranslate | titlecase }}
                </ng-container>
              </clr-dg-column>
            }
            <ng-template clrVirtualScroll let-row [clrVirtualRowsOf]="neuMaengel()">
              <clr-dg-row [clrDgItem]="row">
                <clr-dg-cell>
                  <cds-icon shape="times" (click)="deleteNewMangel(row)" class="cursor-pointer" />
                </clr-dg-cell>

                @for (cell of columns; track $index) {
                  <clr-dg-cell class="name-cell">{{ row[cell] | tablePrettyPrint }}</clr-dg-cell>
                }
              </clr-dg-row>
            </ng-template>
            <clr-dg-footer>{{ neuMaengel().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        </div>
      </clr-wizard-page>
    } @else {
      <clr-wizard-page [clrWizardPageNextDisabled]="!savedSelectedMaengel().length" class="d-f col h-100 h-100-parent">
        <ng-template clrPageTitle>
          {{ 'Existierende Mängel auswählen' | mrTranslate }}
          <app-all-selected-btn
            class="btn-sm"
            [(selected)]="selectedMaengel"
            [all]="maengelFilterStore.filteredRows()" />

          @if (maengelFilterStore.filteredRows().length != maengel().rows.length) {
            <button class="btn btn-primary btn-sm btn-icon" (click)="maengelFilterStore.deleteAllFilters()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="filter-off" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Alle Filter zurücksetzen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          }
          @if (savedSelectedMaengel().length) {
            <button
              class="btn btn-primary btn-sm nym clr-align-self-center"
              (click)="selectedMaengel.set([]); savedSelectedMaengel.set([])">
              {{ 'Auswahl zurücksetzen' | mrTranslate }}
            </button>
          }
          <ng-container *ngTemplateOutlet="newMangelCheckbox" />
        </ng-template>
        <ng-template clrPageNavTitle>{{ 'Mängel auswählen' | mrTranslate }}</ng-template>
        @defer (on viewport) {
          @if (maengel().columns.length) {
            <clr-datagrid
              class="datagrid-compact fill-space"
              [clrDgItemsIdentityFn]="row => row?.omazsid"
              [clrDgRowSelection]="true"
              [clrDgSelectionType]="'multi'"
              [clrDgSelected]="selectedMaengel()"
              (clrDgSelectedChange)="selectedMaengel.set($event)">
              @for (column of maengel().columns; track column.id) {
                <clr-dg-column [clrDgField]="column.id">
                  <clr-dg-filter [attr.data-test-id]="'datagrid-new-auftrag-maengel-col-filter-' + column.id">
                    <app-column-filter
                      #maengel
                      [column]="column"
                      [objektTypIconValue]="maengelFilterStore.iconMap()"
                      [uniqueColumnValues]="maengelFilterStore.uniqueValues()[column.id]"
                      (changes)="maengelFilterStore.onChange($event)" />
                  </clr-dg-filter>

                  <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                    {{ column.id | titlecase | mrTranslate }}
                  </ng-container>
                </clr-dg-column>
              }
              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="maengelFilterStore.filteredRows()"
                [clrVirtualRowsTrackBy]="(_, row) => row?.omazsid"
                [clrVirtualRowsItemSize]="33">
                <clr-dg-row [clrDgItem]="row">
                  @for (cell of maengel().columns; track cell.id) {
                    <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                  }
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>{{ maengelFilterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>

            <div class="datagrid-compact" style="max-height: 250px">
              <div class="grid datagrid" id="saved-maengel-grid-container">
                <div class="border-table h-100 scroll">
                  @let ignoreCols = ['sperrstatus', 'lfstatus'];
                  <table class="table margin-0-t table-compact">
                    <thead style="position: sticky; top: -1px; z-index: 3">
                      <tr>
                        <th class="left name-cell">{{ 'Löschen' | mrTranslate }}</th>

                        @for (column of maengel().columns; track column.id) {
                          @if (!(column.id | hideIDColumns: ignoreCols)) {
                            <th class="left name-cell">{{ column.id | titlecase | mrTranslate }}</th>
                          }
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of savedSelectedMaengel(); track row.omazsid) {
                        <tr>
                          <td class="left name-cell">
                            <button
                              class="btn btn-link w-h-auto"
                              (click)="deleteFromSaved('Maengel', $index)"
                              [title]="'vom Auswahl löschen' | mrTranslate">
                              <cds-icon shape="times" />
                            </button>
                          </td>
                          @for (cell of maengel().columns; track cell.id) {
                            @if (cell.id.toLowerCase() == 'typ') {
                              <td class="left name-cell fill-black">
                                <cds-icon
                                  class="grid-icon"
                                  [title]="row['typ']"
                                  size="28"
                                  [shape]="row['typ_icon'] ? 'objekttyp' + row['typ_icon'] : 'unknown-status'" />
                              </td>
                            } @else if (!(cell.id | hideIDColumns: ignoreCols)) {
                              <td class="left name-cell">{{ row[cell.id] | tablePrettyPrint }}</td>
                            }
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <div class="datagrid-footer">
                  <span class="datagrid-footer-select">
                    <cds-icon size="18" shape="checkbox-list" />
                    &nbsp;{{ savedSelectedMaengel().length }}
                  </span>
                </div>
              </div>
            </div>
          }
        } @placeholder {
          <clr-spinner class="centred" />
        }
      </clr-wizard-page>
    }

    @if (isHxGN_Interface) {
      <clr-wizard-page class="h-100">
        <ng-template clrPageTitle>{{ 'Plankosten' | mrTranslate }}</ng-template>

        <app-kostenerfassung
          [isPlankosten]="true"
          [inforObjCount]="savedSelectedObjekte().length"
          (getPlankostenEvent)="kostenTable.set($event)" />
      </clr-wizard-page>
    }

    <clr-wizard-page
      [clrWizardPagePreventDefaultNext]="true"
      [clrWizardPageNextDisabled]="trial"
      (clrWizardPageOnCommit)="onSubmit()">
      <ng-template clrPageTitle>
        {{ 'Zusammenfassung' | mrTranslate }}
        @if (isSentLoading()) {
          <clr-spinner class="margin-10-l" style="vertical-align: middle" [clrInline]="true" [clrSmall]="true" />
        }
      </ng-template>
      <ng-template clrPageNavTitle>{{ 'Zusammenfassung' | mrTranslate }}</ng-template>
      @let value = auftragGroup.value;
      <table style="width: 100%">
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Titel' | mrTranslate }}:</td>
          <td>{{ value.titel }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Auftragnehmer' | mrTranslate }}:</td>
          <td>{{ (firmen() | find: 'ID' : value.auftragnehmer)?.mFirma }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Auftragsgruppe' | mrTranslate }}:</td>
          <td>{{ (gruppen() | find: 'id' : value.auftragsgruppe)?.Bezeichnung }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Startdatum' | mrTranslate }}:</td>
          <td>{{ value.startdate | localeDate }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Enddatum' | mrTranslate }}:</td>
          <td>{{ value.enddate | localeDate }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Auftragsart' | mrTranslate }}:</td>
          <td>{{ value.auftragsart }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Auftragsnummer' | mrTranslate }}:</td>
          <td>{{ value.auftragsnr }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Kostenart' | mrTranslate }}:</td>
          <td>{{ value.kostenart }}</td>
        </tr>
        <tr style="height: 22px">
          <td style="width: 25%">{{ 'Bemerkung' | mrTranslate }}:</td>
          <td>{{ value.bemerkung }}</td>
        </tr>
      </table>
      <br />
      @if (isObjectSelect() && savedSelectedObjekte().length; as objLength) {
        @let hideArr = [];
        <h4 style="margin-top: 0.6em">{{ 'Ausgewählte Objekte' | mrTranslate }}: {{ objLength }}</h4>
        <table class="table table-compact" style="display: block; overflow-y: auto; margin-top: 0.6em">
          <thead>
            <tr>
              @for (column of objekte().columns; track column.id) {
                @if (!(column.id | hideIDColumns: hideArr)) {
                  <th class="left">{{ column.id | titlecase | mrTranslate }}</th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (row of savedSelectedObjekte(); track row.OSTAMMID) {
              <tr>
                @for (cell of objekte().columns; track cell.id) {
                  @if (!(cell.id | hideIDColumns: hideArr)) {
                    <td class="left"><app-icon-dg-cell [row]="row" [column]="cell" /></td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      }
      @if (neuMaengel().length; as neuMaengelLength) {
        <h4 style="margin-top: 0.6em">{{ 'Neu angelegte Mängel' | mrTranslate }}: {{ neuMaengelLength }}</h4>
        <table class="table table-compact" style="overflow-y: auto; margin-top: 0.6em">
          <thead>
            <tr>
              <th class="left">{{ 'titel' | titlecase | mrTranslate }}</th>
              <th class="left">{{ 'beschreibung' | titlecase | mrTranslate }}</th>
              <th class="left">{{ 'umfang' | titlecase | mrTranslate }}</th>
              <th class="left">{{ 'mengeneinheit' | titlecase | mrTranslate }}</th>
              <th class="left">{{ 'bemerkung' | titlecase | mrTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of neuMaengel(); track $index) {
              <tr>
                <td class="left">{{ row.titel }}</td>
                <td class="left" [title]="row.beschreibung">{{ row.beschreibung | dotDotDot: 30 }}</td>
                <td class="left">{{ row.umfang }}</td>
                <td class="left">{{ row.mengeneinheit }}</td>
                <td class="left" [title]="row.bemerkung">{{ row.bemerkung | dotDotDot: 30 }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (savedSelectedMaengel().length; as selMaengelLength) {
        <h4 style="margin-top: 0.6em">{{ 'Ausgewählte Mängel' | mrTranslate }}: {{ selMaengelLength }}</h4>
        <table class="table table-compact" style="display: block; overflow-y: auto; margin-top: 0.6em">
          <thead>
            <tr>
              @for (column of maengel().columns; track column.id) {
                @if (!(column.id | hideIDColumns)) {
                  <th class="left">{{ column.id | titlecase | mrTranslate }}</th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (row of savedSelectedMaengel(); track $index) {
              <tr>
                @for (cell of maengel().columns; track cell.id) {
                  @if (!(cell.id | hideIDColumns)) {
                    <td class="left"><app-icon-dg-cell [row]="row" [column]="cell" /></td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      }
      @if (kostenTable().columns) {
        <clr-datagrid class="datagrid-compact">
          @for (column of kostenTable().columns; track column.id) {
            <clr-dg-column>
              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['kostentyp', 'kostenid'] }">
                {{ column.id | titlecase | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }

          <!-- PERSONAL ROWS -->
          @let personal = kostenTable().rows.personal;
          <ng-container *ngTemplateOutlet="rows; context: { $implicit: personal, title: 'Personal' }" />
          <!-- MATERIAL ROWS -->
          @let material = kostenTable().rows.material;
          <ng-container *ngTemplateOutlet="rows; context: { $implicit: material, title: 'Material' }" />
          <!-- MASCHINE ROWS -->
          @let maschine = kostenTable().rows.maschine;
          <ng-container *ngTemplateOutlet="rows; context: { $implicit: maschine, title: 'Maschinen' }" />
          <!-- FREMDLEISTUNG ROWS -->
          @let fremdleistung = kostenTable().rows.fremdleistung;
          <ng-container *ngTemplateOutlet="rows; context: { $implicit: fremdleistung, title: 'Fremdleistungen' }" />

          <ng-template #rows let-rows let-title="title">
            @if (rows.length) {
              <clr-dg-row>
                <clr-dg-cell class="headlineRow">
                  {{ title | mrTranslate | uppercase }}
                  <span class="badge badge-success" style="margin-left: 0.3em">{{ rows.length }}</span>
                </clr-dg-cell>
              </clr-dg-row>
              @for (row of rows; track $index) {
                <clr-dg-row>
                  @for (cell of kostenTable().columns; track cell.id) {
                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
              }
            }
          </ng-template>

          <clr-dg-footer>
            @let count = personal.length + material.length + maschine.length + fremdleistung.length;
            <div>{{ count }} {{ 'Zeilen' | mrTranslate }}</div>
            <div style="display: flex; justify-content: space-evenly">
              <strong>{{ 'Kosten' | mrTranslate }}: {{ kostenTable().summary.kosten }}&nbsp;€</strong>
              <strong>{{ 'Plankosten' | mrTranslate }}: {{ kostenTable().summary.plankosten }}&nbsp;€</strong>
            </div>
          </clr-dg-footer>
        </clr-datagrid>
      }
    </clr-wizard-page>
  </clr-wizard>
}

@if (isBaseItemModalOpen()) {
  <app-baseitems-wrapper
    [(isModalOpen)]="isBaseItemModalOpen"
    [route]="{ tabelle: 'KAUFUS' }"
    (refreshList)="stoerursache.set($event)" />
}
